<template>
    <el-drawer
        title="发货"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                v-if="itemData"
                :model="formDatas"
                :rules="rules"
                ref="formDatas"
                label-position="top"
            >
                <el-form-item prop="expressName">
                    <span slot="label">
                        快递公司:    
                        <small>如果没有所需的快递公司，请联系研发进行添加</small>
                    </span>
                    <el-select v-model="formDatas.expressName" size="medium" placeholder="请选择快递公司">
                        <el-option v-for="(item,index) in expressList" :key="index" :value="item.expressName" :label="item.expressName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="expressNo" label="运单号:" >
                    <el-input v-model="formDatas.expressNo" placeholder="请输入运单号" size="medium" maxlength="40"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import {fetchExpress} from '@/assets/js/commonApi';
const defaultFormData = {
    expressName:'',
    expressNo:''
}
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas: {
                ...defaultFormData,
            },
            rules:{
                expressName:[{required: true, message: '请选择快递公司'}],
                expressNo:[{required: true, message: '请输入运单号'}]
            },
            itemData:null,
            expressList:[]
        }
    },
    created(){
        this.getExpressList();
    },
    methods:{
        close(){
            this.formDatas = { ...defaultFormData };
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
        },
        show(data){
            this.itemData = data;
            this.formDatas = {
                ...defaultFormData,
                orderId:data.id,
                sn: data.sn
            }
            this.drawerShow = true;
        },
        getExpressList(){
            fetchExpress().then((res) => {
                const {state,result} = res.data;
                if(state == 1){
                    this.expressList = result;
                }
            }).catch(() => {})
        },
        submitForm(){
            this.$refs["formDatas"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/activiOrder/deliverGoods',
                        data:this.formDatas,
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg, result } = res.data;
                            if (state == 1 && (!result || !result.importErrorDetailVOList)) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>